import type { Limits } from '@/entities/limits';
import request from '@/shared/api/request';

export const getTeamLimits = (uuid: string): Promise<Limits> =>
  request({
    url: `/teams/${uuid}/limits/`,
  });
